export default __webpack_public_path__ + "static/media/C5.2840848f.svg";